import React, { useCallback } from "react";

import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";
import { DeviceTesterTestState } from "../../../types/Device.types";
import {
  useDeviceTesterDispatchContext,
  useDeviceTesterStateContext,
} from "../../device-tester-context-provider/DeviceTesterContextProvider";

import { ResultsStartAudioTestButton } from "./ResultsStartAudioTestButton";

export const ConnectedStartAudioTestButton: React.FC = () => {
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();
  const { deviceTesterState } = useDeviceTesterStateContext();

  // Dispatch audio test
  const dispatchAudioTest = useCallback(async () => {
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
      state: DeviceTesterTestState.AUDIO,
    });
  }, [deviceTesterDispatch]);

  return (
    <ResultsStartAudioTestButton
      dispatchAudioTest={dispatchAudioTest}
      isInfoFetched={deviceTesterState.isInfoFetched}
      isAcsTokenFetched={deviceTesterState.isAcsTokenFetched}
    />
  );
};
